<section class="Receipt add-notes">	
	<div class="container">
	   <h2 class="title text-center">Add notes </h2>			
			<div class="row mt-4 pt-4">
		 		<div class="col-md-8 text-center mx-auto ">
				    <div class="promo">
				  		<p> 
				  			 <textarea placeholder="Write note here..." [(ngModel)]="notes"></textarea> 
				  		</p>
				  		<p> <button (click)="addNote()"> ADD Note</button></p>
				    </div>		   
				</div>
			</div>
			<div class="row mt-4 pt-4">
		 		<div class="col-md-6 " *ngFor="let not of notesArr">
				    <div class="not_text">
							<div class="media position-relative nots_image">
							  <img loading="lazy" [src]="imgUrl" (error) ="onImgError($event)"class="mr-3" alt="...">
							  <div class="media-body">
								<a class="delet" (click)="deletNote(not.id)"> Delete </a>
								<h5 class="">{{name}}</h5>
								<a>{{not.created*1000 | date: 'medium'}}</a>
							  </div>
							</div>
							<p>{{not.description}}</p>
				    </div>		   
				</div>
			</div>
	</div>
</section>